import { Attachment } from "core/src";

export interface MessageComposerState {
    sendingMessage: boolean;
    attachments?: Attachment[];
    isUploadingAttachment?: boolean;
    error?: string;
    errorType?: string;
}

export const initialMessageComposerState: MessageComposerState = {
    sendingMessage: false,
    attachments: undefined,
    isUploadingAttachment: false,
    error: undefined,
    errorType: undefined,
};
